import React, { useContext } from 'react'
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  BrowserRouter,
  Routes,
  NavLink,
} from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { AuthContext } from '../../context/auth';
import PageNotFound from '../../pages/404';
import Home from '../../pages/Home';
import Login from '../../pages/Login';
import Register from '../../pages/Register';
import { removeLocalStorage } from '../helper/auth';
import toast from 'react-hot-toast';



export default function Main() {


  const [auth, setAuth] = useContext(AuthContext);

  const Logout = () => {
    setAuth(null)
    removeLocalStorage("auth")
    const gauth = getAuth();
    signOut(gauth).then(() => {
      toast.success("Logged out Successful")
    }).catch((error) => {
      console.log(error)
    });
  }
  return (
    <ul className="nav shadow mb-2 d-flex justify-content-center">
      <li className="nav-item">
        <NavLink className="nav-link" to="/">Home</NavLink>
      </li>

      {auth !== null && auth !== undefined ? (

        <>
          <a className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" >
            {auth?.email}
          </a>

          <ul className="dropdown-menu">
          <li >
              <NavLink  className="nav-link " to="/dashboard">Dashboard</NavLink>
            </li>
            <li >
              <NavLink onClick={Logout} className="nav-link " to="/login">Logout</NavLink>
            </li>
          </ul>
        </>


      ) : (
        <>

          <li className="nav-item">
            <NavLink className="nav-link" to="/register">Register</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link " to="/login">Login</NavLink>
          </li>

        </>
      )}



    </ul>

  )
}

